import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import asyncComponent from "./AsyncComponent";

const Home = asyncComponent(() =>
  import("./containers/Home").then(module => module.default)
);

const App = asyncComponent(() => import("./App").then(module => module.default));

const NotFound = asyncComponent(() =>
  import("./components/NotFound").then(module => module.default)
);
const BbcNews = asyncComponent(() =>
  import("./containers/BbcNews").then(module => module.default)
);
const BbcSports = asyncComponent(() =>
  import("./containers/BbcSports").then(module => module.default)
);
const BbcTechnology = asyncComponent(() =>
  import("./containers/BbcTechnology").then(module => module.default)
);
const BbcWorld = asyncComponent(() =>
  import("./containers/BbcWorld").then(module => module.default)
);
const BbcBusiness = asyncComponent(() =>
  import("./containers/BbcBusiness").then(module => module.default)
);

const Routes = () => (
  <Router>
    <App>
      <div>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/bbc-news" component={BbcNews} />
          <Route path="/bbc-sports" component={BbcSports} />
          <Route path="/bbc-technology" component={BbcTechnology} />
          <Route path="/bbc-world" component={BbcWorld} />
          <Route path="/bbc-business" component={BbcBusiness} />
          <Route component={NotFound} />
        </Switch>
      </div>
    </App>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js